<template>
    <div>
        <daily-scrum :dailyScrum="dailyScrum" :loggedInEmployee="loggedInEmployee" :isSubmitting="false" @save="onSave" @cancel="onCancel" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import DailyScrumEditor from '@/components/dailyScrum/DailyScrumEditor.vue';

    export default {
        props: {},
        components: {
            DailyScrumEditor
        },
        data() {
            return {
                dailyScrum: {
                    id: null,
                    createdDateUtc: null,
                    updatedDateUtc: null,
                    scrumDateUtc: null,
                    employee: {
                        id: '94e94d5e-bf71-4f1a-84b4-b1824d3ee5e0'
                    },
                    items: [
                        {
                            id: null,
                            question: 'What did you do yesterday?',
                            answer: null,
                            rankType: 0
                        },
                        {
                            id: null,
                            question: 'What are your goals for today?',
                            answer: null,
                            rankType: 0
                        },
                        {
                            id: null,
                            question: 'Are there any blockers that stand in your way?',
                            answer: null,
                            rankType: 0
                        },
                        // {
                        //     id: null,
                        //     question: 'How are you feeling today Danny?',
                        //     answer: null,
                        //     rankType: 2
                        // },
                    ]
                }
            }
        },
    	computed: {
    		...mapGetters({
    			loggedInEmployee: 'loggedInEmployee'
    		})
    	},
        methods: {
            onSave() {

            },
            onCancel() {

            }
        }
    };
</script>

<style>
</style>
